module.exports = __webpack_public_path__ + "static/media/stadium.3c2149b0.svg";